import axios from 'axios';
import React, { useEffect, useState } from "react";
import Particles from "react-particles-js";
import Layout from "../components/Layout";
import Socialicons from "../components/Socialicons";


function Home({lightMode}){
  const [information, setInformation] = useState("");
  const paramConfig = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        // value: "#ffffff"
        value: "#ffedb0"
      },
      opacity: {
        value: 0.2
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: "top",
        out_mode: "out"
      }
    }
  }

  const paramConfigLight = {
    particles: {
      number: {
        value: 160,
        density: {
          enable: false
        }
      },
      color: {
        // value: "#000000"
        value: "#228B92"
      },
      opacity: {
        value: 0.1
      },
      size: {
        value: 5,
        random: true,
        anim: {
          speed: 4,
          size_min: 0.3
        }
      },
      line_linked: {
        enable: false
      },
      move: {
        random: true,
        speed: 1,
        direction: "top",
        out_mode: "out"
      }
    }
  };
  useEffect(() =>{
    axios.get('/api/information')
    .then( response => {
      setInformation(response.data);
    })
  }, [])
  return (
    <Layout>
      <div className="mi-home-area mi-padding-section">
        <div className={lightMode ? "" : "spy"}>
          <div className={lightMode ? "" : "eye"}></div>
          <div className={lightMode ? "" : "eye"}></div>
        </div>
        <div className={lightMode ? "" : "spy2"}>
          <div className={lightMode ? "" : "eye2"}></div>
          <div className={lightMode ? "" : "eye2"}></div>
        </div>
        <div className={lightMode ? "" : "spy3"}>
          <div className={lightMode ? "" : "eye3"}></div>
          <div className={lightMode ? "" : "eye3"}></div>
        </div>
        <img className={lightMode ? 'react-image-light' : 'react-image-dark'} src="/images/TB_ReactLogo.png" alt="react-logo" />
        <img className={lightMode ? 'js-image-light' : 'js-image-dark'} src="/images/TB_JSLogo.png" alt="js-logo" />
        <img className={lightMode ? 'css-image-light' : 'css-image-dark'} src="/images/TB_CSS.png" alt="css-logo" />
        <img className={lightMode ? 'node-image-light' : 'node-image-dark'} src="/images/TB_Node.png" alt="node-logo" />
        <Particles className="mi-home-particle" params={lightMode? paramConfigLight : paramConfig} />
        <div className="container">
          <div className="row justify-content-center">
            <div className="col-lg-10 col-12">
              <div className="mi-home-content">
                <h1>
                  Hi, I am <span className="color-theme">{information.name}</span>
                </h1>
                <p>{information.aboutContent}</p>
                <Socialicons bordered />
              </div>
            </div>
          </div>
        </div>
      </div>
    </Layout>
  );
}

export default Home;
